import { Box, Typography } from '@mui/material';
import { ContainerIframes } from './ContainerIframes';
import { useSelector } from 'react-redux';
import { RootState } from 'shared/store/store';
import styles from './styles/IframesSidebar.module.scss';

export const IframesSidebar = () => {
  const iframesState = useSelector((state: RootState) => state.iframes);

  return (
    <Box className={styles.iframesSidebarContainer}>
      <Box className={styles.iframesHeader}>
        <Typography variant="h6" className={styles.iframesTitle}>
          Herramientas ({iframesState.iframes.length})
        </Typography>
      </Box>
      <Box className={styles.iframesContent}>
        <ContainerIframes iframes={iframesState.iframes} />
      </Box>
    </Box>
  );
}; 